module.exports = __webpack_public_path__ + "img/gonghu.57355006.png";